import React from "react";
import { useNavigate } from "react-router-dom";
import './BeltLayout.css';

const BeltLayout = ({
  beltImage,
  beltName,
  patternName,
  videoLinkText,
  diagramImage,
  movesHtml,
  techniqueHtml,
  sparringText,
  fundamentalmovementsHtml, // Add this new prop
}) => {
  const navigate = useNavigate();
  return (
    <div className="belt-page">
      <div className="belt-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2 className="belt-name">{beltName}</h2>
        <div
          className="pattern-name"
          dangerouslySetInnerHTML={{ __html: patternName }}
        />
        <div
          className="video-link"
          dangerouslySetInnerHTML={{ __html: videoLinkText }}
        />
        <div className="video-diagram-row">
          <img src={diagramImage} alt="Pattern Diagram" className="diagram-image" />
          <div
            className="moves-list"
            dangerouslySetInnerHTML={{ __html: movesHtml }}
          />
        </div>
        {/* Technique Section */}
        <h4 className="technique-heading"></h4>
        <div
          className="technique-text"
          dangerouslySetInnerHTML={{ __html: techniqueHtml }}
        />
        {/* Sparring Section */}
        <h4 className="sparring-heading"></h4>
        <div
          className="sparring-text"
          dangerouslySetInnerHTML={{ __html: sparringText }}
        />
        {/* Fundamental Movements Section */}
        <h4 className="fundamental-movements-heading">Fundamental Movements</h4>
        <div
          className="fundamental-movements-text"
          dangerouslySetInnerHTML={{ __html: fundamentalmovementsHtml }}
        />
      </div>
    </div>
  );
};

export default BeltLayout;
